import { mapGetters, mapActions } from 'vuex'
import { isUndefined } from 'lodash'
import globaltypes from '../../store/globaltypes'
import config from '../../config'

export default {
  name: 'toolbar',
  components: {},
  props: [],
  data () {
    return {
      multiLanguage: config.multiLanguage
    }
  },
  computed: {
    ...mapGetters({
      isSignedIn: globaltypes.user.getters.signedIn,
      user: globaltypes.user.getters.currentUser
    }),
    title () {
      var title = this.$route.name
      if (this.$route.meta.titleKey) title = this.$i18n.t(this.$route.meta.titleKey)
      else if (!isUndefined(this.$route.meta.displayName)) title = this.$route.meta.displayName
      if (this.$route.params.cropname) title = this.$route.params.cropname
      return this.$options.filters.capitalize(title)
    },
    parent () {
      if (!this.$route.meta.parent) return null
      var parent = this.$router.resolve({
        name: this.$route.meta.parent
      })
      return parent.route
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions({
      logout: globaltypes.user.actions.signOut,
      setLocale: globaltypes.user.actions.setLocale
    }),
    selectLocale (locale) {
      this.setLocale(locale)
    },
    onBackClick () {
      this.$router.back()
    }
  }
}
